import { render, staticRenderFns } from "./AdInsightsChat.vue?vue&type=template&id=44512789&scoped=true"
import script from "./AdInsightsChat.vue?vue&type=script&lang=js"
export * from "./AdInsightsChat.vue?vue&type=script&lang=js"
import style0 from "./AdInsightsChat.vue?vue&type=style&index=0&id=44512789&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44512789",
  null
  
)

export default component.exports